module.exports = __webpack_public_path__ + "img/code.d118d050.png";